"use strict";var _interopRequireDefault=require("@babel/runtime/helpers/interopRequireDefault");exports.__esModule=!0,exports.default=getWaterMark;var _getWaterMarkConfig=_interopRequireDefault(require("./utils/getWaterMarkConfig")),_watermark=require("./packages/h5-watermark/watermark");function getWaterMark(e,r){return void 0===e&&(e=""),new Promise((function(t,a){(0,_getWaterMarkConfig.default)({pageInfo:e}).then((function(e){try{var u=(0,_watermark.generateWatermark)(e,r);t(u)}catch(e){a(e)}}))}))}module.exports=exports.default,module.exports.default=exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/gdt-jsapi/getWaterMark.js
// module id = 9kqh
// module chunks = 23